module.exports = __webpack_public_path__ + "img/code.7553dab0.png";